<div class="empty">
  <p class="empty__caption">
    <ng-content></ng-content>
  </p>
  @if (icon) {
    <ftr-icon [icon]="icon" color="GreyLighter" size="Max"></ftr-icon>
  }
</div>
